import Component from '../core/Component'
import Flickity from 'flickity'
import { toggleClass } from '../utils/dom'
import enquire from 'enquire.js'
import { queries } from '../core/config'

export default class ArticleSection extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            dots: [],
            cells: [],
            content: null
        }


        this.isDragging = false
        this.flickity = null

        this.enquireHandler = {
            match: this.attach,
            unmatch: this.detach
        }
    }

    prepare() {
        enquire.register(queries.mediumMax, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(queries.mediumMax, this.enquireHandler)
    }

    attach = () => {
        this.flickity = new Flickity(this.ref.content, {
            cellSelector: '[data-ref="cell"]',
            pageDots: false,
            prevNextButtons: false,
            cellAlign: 'left',
            contain: true
        })

        this.flickity.on('dragStart', this.handleDragStart)
        this.flickity.on('dragEnd', this.handleDragEnd)
        this.flickity.on('select', this.handleSelect)

        this.ref.content.addEventListener('click', this.handleClick)

        this.ref.dots.forEach(dot => dot.addEventListener('click', this.handleDotClick))
    }

    detach = () => {
        if (this.flickity) {
            this.flickity.destroy()
            this.flickity = null
        }

        this.ref.content.removeEventListener('click', this.handleClick)
        this.ref.dots.forEach(dot => dot.removeEventListener('click', this.handleDotClick))
        this.isDragging = false
    }

    handleSelect = index => {
        this.ref.dots.forEach((dot, i) => toggleClass(dot, 'is-active', i === index))
    }

    handleDotClick = event => {
        const index = this.ref.dots.indexOf(event.currentTarget)

        this.show(index)
    }

    handleClick = event => {
        if (this.isDragging) {
            event.stopPropagation()
            event.preventDefault()
        }
    }

    handleDragStart = () => {
        clearTimeout(this.dragEndTimer)
        this.isDragging = true
    }

    handleDragEnd = () => {
        clearTimeout(this.dragEndTimer)
        this.dragEndTimer = setTimeout(() => {
            this.isDragging = false
        }, 100)
    }

    show(index) {
        if (this.flickity) {
            this.flickity.select(index)
        }
    }
}
